export const mergeDataFunction = (prevList, addedList, source) => {
  for (const el in addedList) {
    const exEl = prevList.find(x => x.id === addedList[el].id)
    if (exEl) {
      if (source === 'search') {
        prevList.find(x => x.id === addedList[el].id).sourceSearchList = true
      } else {
        prevList.find(x => x.id === addedList[el].id).sourceSavedList = true
      }
    } else {
      prevList.unshift(addedList[el])
    }
  }
  return prevList
}

export const queryGenerator = (baseQueryString, finalQueryString, columns, isProfile) => {
  const baseQuery = baseQueryString

  const removeIndexFromField = (field) => field.endsWith('[0]') ? field.slice(0, -3) : field

  const buildQueryFields = (columns, depth = 0, idFieldAdded = false, isQueryProfile = true) => {
    let queryFields = ''
    const nestedObjectsMap = new Map()

    columns
      .filter((column) => ((column.visible && !column.withoutQueryField) || column.internVisible) &&
                          (isProfile && isQueryProfile ? column.dataField.includes('profiles[0]') : !column.dataField.includes('profiles[0]')))
      .forEach((column) => {
        let field = column.dataField

        if (field.includes('profiles[0]')) {
          field = field.substring(field.indexOf('profiles[0]') + 12)
        }

        if (field.includes('.')) {
          const [nestedField, ...nestedFields] = field.split('.')
          const currentNestedObject = nestedObjectsMap.get(nestedField) || {}
          nestedObjectsMap.set(nestedField, currentNestedObject)

          currentNestedObject.fields = currentNestedObject.fields || []
          currentNestedObject.fields.push({ dataField: nestedFields.join('.'), visible: true })
        } else {
          field = removeIndexFromField(field)
          if (!idFieldAdded && field !== 'field_001') {
            queryFields += `${'  '.repeat(depth)}field_001\n`
            idFieldAdded = true
          }
          queryFields += `${'  '.repeat(depth)}${field}\n`
        }
      })

    nestedObjectsMap.forEach((nestedObject, key) => {
      const hasIdField = nestedObject.fields.some(field => field.dataField === 'field_001')
      queryFields += `${'  '.repeat(depth)}${removeIndexFromField(key)} {\n${buildQueryFields(nestedObject.fields, depth + 1, hasIdField, false)}${'  '.repeat(depth)}}\n`
    })

    return queryFields
  }

  const queryFields = buildQueryFields(columns)

  const finalQuery = `
    ${queryFields}
    ${finalQueryString}
  `
  const completeQuery = baseQuery + finalQuery
  return completeQuery
}

export const calculateEvaluationsExt = (rowData) => {
  let listOfEvaluations = ''
  if (rowData.vLABEvaluations) {
    listOfEvaluations = Array.prototype.map.call(rowData.vLABEvaluations, function (item) { return item.cRMMitarbeiter.vorname + ': ' + item.sEMINARCasequality.casequality }).join(', ')
  }
  return listOfEvaluations
}

export const fundraisingGoalExt = (rowData) => {
  const lastItem = rowData?.cRMAddress?.profiles[0]?.cRMFundingProfileV2s?.slice(-1)[0]
  return lastItem?.moneyinCHF || 0
}

export const calcIsDisclaimerExt = (rowData) => {
  return rowData.iSDisclaimerAccepttobecontacted === '1' ? 'Don\'t send information' : null
}

export const calcJoinedSuisseModulesExt = (rowData) => {
  const list = rowData.eVENTQuestionnairejoinedModulesJOrderIS2025s
    if (!list?.length) return null

    return list
      .map(x => x.eVENTEventStartupISModulesInnosuisse2025)
      .filter(Boolean)
      .sort((a, b) => a.sort - b.sort)
      .map(x => x.joinedInnosuissemodules)
      .join(', ')
}

export const calcInnosuisseprogramsExt = (rowData) => {
  const list = rowData.eVENTQuestionnaireoprogramsJOrderIS2025s
    if (!list?.length) return null

    return list
      .map(x => x.eVENTQuestionnaireOtherISprogramsIS2025)
      .filter(Boolean)
      .sort((a, b) => a.sortierung - b.sortierung)
      .map(x => x.innosuisseprograms)
      .join(', ')
}

export const calcDescribesyourcurrentinterestExt = (rowData) => {
  const list = rowData.eVENTQuestionnairedinterestJOrderIS2025s
    if (!list?.length) return null

    return list
      .map(x => x.eVENTQuestionnairedescribesinterestIS2025)
      .filter(Boolean)
      .sort((a, b) => a.sort - b.sort)
      .map(x => x.describesyourcurrentinterest)
      .join(', ')
}

export const calcUnSustainableDevelopmentGoalsExt = (rowData) => {
  const list = rowData.eVENTQuestionnaireUNDevGoalsJOrderIS2025s
    if (!list?.length) return null

    return list
      .map(x => x.eVENTQuestionnaireUNDevGoalsIS2025)
      .filter(Boolean)
      .sort((a, b) => a.sort - b.sort)
      .map(x => x.uNSustainableDevelopmentGoals)
      .join(', ')
}

export const calcEventCourseCohortExt = (rowData) => {
  const event = rowData.crmEvent
    if (!event) return null

      const parts = [
      event.course_no,
      event.eventlisttitleEN,
      event.sortierdatum
        ? new Date(event.sortierdatum).toLocaleDateString('de-DE')
        : null,
      event.gRUNDWERTELocationInnosuiss?.locationname
    ]

    return parts.filter(Boolean).join(' - ')
}

export const calcValueByEventPoolId = (rowData, eventPoolId, eventDate, eventPoolIsCoursesList, eventPoolIsMixedList, isEventVal, isCoursesVal) => {
  const diffBestellungId = 1032713
  const currBestellungId = rowData?.field_001
  if (!eventPoolId) return isEventVal
  const isCourse = eventPoolIsCoursesList.includes(eventPoolId)
  const isMixedAndOld = eventPoolIsMixedList.includes(eventPoolId) && currBestellungId && currBestellungId <= diffBestellungId

  if (isCourse || isMixedAndOld) {
    return isCoursesVal
  }

  return isEventVal
}

export const calcTotalExt = (rowData) => {
  return (
    // statusId 2 = Closed, InvestmentStage 10 = Trade Sale, InvestmentType 9 = Loan, 15 = Revenue
    rowData?.cRMAddress?.profiles[0]?.cRMFundingProfileV2s?.reduce((total, fund) => {
      if (fund.statusId === 2 && fund.investmentsStage !== 10 && ![9, 15].includes(fund.investmentsTypeId)) {
        return total + fund.moneyinCHF
      }
      return total
    }, 0) || 0
  )
}

export const latestStageExt = (rowData) => {
  return (rowData?.cRMAddress?.profiles?.length && rowData?.cRMAddress?.profiles[0]?.cRMFundingProfileV2s?.slice(-1)[0]?.investmentsStage) ?? null
}

export const latestClosingDateExt = (rowData) => {
  let lastItem = null
  if (rowData?.cRMAddress && rowData?.cRMAddress?.profiles && rowData?.cRMAddress?.profiles[0]?.cRMFundingProfileV2s) {
    lastItem = rowData?.cRMAddress?.profiles[0]?.cRMFundingProfileV2s?.slice(-1)[0]
  }
  return lastItem?.closingdate ? new Date(lastItem.closingdate) : null
}

export const calculateSectorsExt = (rowData) => {
  let listOfSectors = ''
  if (rowData.cRMAddress && rowData.cRMAddress.profiles && rowData.cRMAddress.profiles[0] && rowData.cRMAddress.profiles[0].pROFILProfilJOINCategories?.length) {
    listOfSectors = Array.prototype.map.call(rowData.cRMAddress.profiles[0].pROFILProfilJOINCategories, function (item) { if (item.pROFILCategory) { return item.pROFILCategory.kategorieDE } else { return '' } }).join(', ')
  }
  return listOfSectors
}

export const calculateReportinggroupsExt = (rowData) => {
  let listOfReportingroups = ''
  if (rowData.cRMAddress && rowData.cRMAddress.profiles && rowData.cRMAddress.profiles[0]?.pROFILProfilJOINReportingGroups !== undefined) {
    listOfReportingroups = Array.prototype.map.call(rowData.cRMAddress.profiles[0].pROFILProfilJOINReportingGroups, function (item) { if (item.pROFILReportingGroup) { return item.pROFILReportingGroup.reportingGroups } else { return '' } }).join(', ')
  }
  return listOfReportingroups
}

export const calculateAgeGroupExt = (rowData) => {
  let ageGroup = ''
  const birthday = rowData.cRMAddress?.birthday

  if (!birthday) return ageGroup

  const birthDate = new Date(birthday)
  const today = new Date()

  const diffInMs = today - birthDate
  const age = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 365.242199))

  if (age <= 25) {
    ageGroup = '25'
  } else if (age <= 30) {
    ageGroup = '26-30'
  } else if (age <= 35) {
    ageGroup = '31-35'
  } else if (age <= 45) {
    ageGroup = '36-45'
  } else {
    ageGroup = '>= 46'
  }

  return ageGroup
}

export const getBirthdayExt = (rowData) => {
  return rowData.cRMAddress?.birthday
    ? new Date(rowData.cRMAddress.birthday).toLocaleDateString('de-DE')
    : null
}

export const getSalutationIdExt = (rowData) => {
  return rowData.cRMAddress?.salutationId || null
}

export const getDisplayExprExt = (item) => {
  return item.geschlecht_PopupExtension ? `${item.ansprechzeile} ${item.geschlecht_PopupExtension}` : `${item.ansprechzeile}`
}

export const getDisplayExprVKExt = (item) => {
  if (item?.cRMAddress?.profiles?.length && item?.cRMAddress?.profiles[0]?.pROFILUntersttzungszuweisungs?.some(support => support.untersttzungId === 1)) {
    return '✓'
  }
  return ''
}

export const getDisplayExprVLExt = (item) => {
  if (item?.cRMAddress?.profiles?.length && item?.cRMAddress?.profiles[0]?.pROFILUntersttzungszuweisungs?.some(support => support.untersttzungId === 4)) {
    return '✓'
  }
  return ''
}

export const getDisplayExprT100Ext = (item) => {
  if (item?.cRMAddress?.profiles?.length && item?.cRMAddress?.profiles[0]?.pROFILUntersttzungszuweisungs?.some(support => support.untersttzungId === 6)) {
    return '✓'
  }
  return ''
}

export const getDisplayExprISExt = (item) => {
  if (item?.cRMAddress?.profiles?.length && item?.cRMAddress?.profiles[0]?.pROFILUntersttzungszuweisungs?.some(support => support.untersttzungId === 7)) {
    return '✓'
  }
  return ''
}

export const getPillStyleExt = (evaluationType) => {
  if (evaluationType === '++' || evaluationType === '+' || evaluationType === 'A') {
    return 'success'
  } else if (evaluationType === 'B') {
    return 'info'
  } else if (evaluationType === '=' || evaluationType === '-' || evaluationType === 'C') {
    return 'primary'
  } else if (evaluationType === 'D') {
    return 'warning'
  } else if (evaluationType === '--' || evaluationType === 'E') {
    return 'danger'
  } else if (evaluationType === 'No qualification' || evaluationType === 'No qualificaton') {
    return 'secondary'
  }
}
